import { adminHttpClient } from "../../../../commons/adminHttpClinet";
import { SuggestedAdvertisers } from "../../../../models/dashboard/marketplace/suggestedAdvertisers";

const getSuggestedAffiliates = () :Promise<SuggestedAdvertisers> =>{

 return adminHttpClient.get(`/api/Admin/AdminMarketplace/get-affiliate-suggested`)

}
export default getSuggestedAffiliates;